<template>
	<div class="">
		<h4 class="text-center title">『해외지사화사업(海外支社化事業)』확장 단계의 시행에 관한 협약</h4>
		<div class="color-navy content text-left text-size-l">
			『해외지사화사업』을 수행함에 있어 해외지사화사업에 참가하는
			<span class="font-bold color-gray-bg pl-1 pr-1 text-size-ml">{{ this.matchData.companyNmKor }}</span> 社(이하 “고객사”)와 사업을 수행하는
			(사)세계한인무역협회 <span class="font-bold color-gray-bg pl-1 pr-1 text-size-ml">{{ this.matchData.marketerNm }}</span> 글로벌 마케터 (이하
			“글로벌마케터”)는 해외지사화사업(확장단계)의 원활한 수행을 위하여 아래와 같이 협약한다.
		</div>
		<div class="color-navy content mt-4 text-size-l">
			<p class="font-bold mb-2">제1조 (사업의 정의)</p>
			『해외지사화사업』이라 함은 산업통상자원부의 주관 하에 (사)세계한인무역협회(이하 “OKTA”), 대한무역투자진흥공사(KOTRA),
			중소벤처기업진흥공단(KOSME)이 국내 중소·중견기업의 해외진출 및 수출을 지원하는 사업으로서, 글로벌마케터가 현지 네트워크를 활용하여 해외에 지사를
			설치할 여력이 부족한 중소중견기업의 현지 지사 역할을 대행하여 수출 및 해외진출을 지원하는 서비스를 제공하는 사업을 의미한다. 본 협약에 따라
			글로벌마케터는 고객사에게 아래에서 정하는 <span class="font-bold color-gray-bg pl-1 pr-1 text-size-ml">확장단계</span> 서비스를 제공한다.
		</div>
		<div class="color-navy content mt-4 text-size-l">
			<p class="font-bold mb-2">제2조 (용어의 정의)</p>
			① 『고객사』라 함은 대한민국 국세청에 사업자등록을 하고 이를 유지하고 있는 중소·중견기업 중 본 협약의 당사자로서 『해외지사화사업』에 참여하는
			기업을 의미한다.<br />
			② 『글로벌마케터』는 OKTA 지회에서 선정 및 배정한 2020 글로벌마케터로서 고객사의 동의에 의해 해외지사화사업을 수행하는 본 협약의 당사자를
			의미한다.<br />
			③ 『OKTA』라 함은 해외지사화사업을 관리하고 조정하는 (사)세계한인무역협회 국제사무국을 의미한다. <br />
			④ 『바이어』라 함은 해외의 제품 및 서비스 수입선을 말한다.
		</div>
		<div class="color-navy content mt-4 text-size-l">
			<p class="font-bold mb-2">제3조 (참여 조건 및 제한)</p>
			소정의 선정절차를 거쳐 참가비를 납부한 기업은 고객사로서 해외지사화사업에 참여할 수 있다. 다만, 본 협약 제 12조 ②항에 의거하여 협약이 해지된
			경우(해지된 당사자와 독점규제 및 공정거래에 관한 법률상 계열회사 관계에 있는 기업을 포함한다) 참여가 제한될 수 있다.
		</div>
		<div class="color-navy content mt-4 text-size-l">
			<p class="font-bold mb-2">제4조 (지원 내용)</p>
			① 본 협약에 따른 글로벌마케터는 고객사에게 아래와 같은 진입단계의 서비스를 제공할 수 있다.<br />
			<div class="online-report-area mt-2 mb-2">
				<table class="online-report-section-table" cellspacing="0" cellpadding="0">
					<thead>
						<tr>
							<th class="col-w20">구분</th>
							<th class="col-w80">지원내용</th>
						</tr>
					</thead>
					<tbody>
						<tr>
							<td class="text-center">진입단계</td>
							<td class="pl-4">기초시장조사</td>
						</tr>
					</tbody>
				</table>
			</div>
			② 상호 이해 제고를 위해 고객사와 글로벌마케터는 해외지사화사업에 참가하는 구체적인 목적을 확장단계 지원서비스 중 협의 후 아래 표 및 첨부3의
			확장단계 추진진도표에 명시한다.<br />
			<div class="online-report-area mt-2 mb-2">
				<table class="online-report-section-table" cellspacing="0" cellpadding="0">
					<thead>
						<tr>
							<th class="col-w40">단계</th>
							<th class="col-w60">지원 서비스</th>
						</tr>
					</thead>
					<tbody>
						<tr>
							<td class="text-center">진입단계</td>
							<td class="pl-4"><p v-for="i in 3" :key="i">시장조사</p></td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
		<div class="color-navy content mt-4 text-size-l">
			<p class="font-bold mb-2">제5조 (지원대상)</p>
			① 글로벌마케터는 고객사와 지원품목을 사전 협의하여 정한다. 지원품목은 고객사의 제조품목 및 주력수출품목, 서비스 1개 품목(HS Code 6단위 기준)으로
			한다.<br />
			<p class="text-size-m pl-4 pt-1">1. 지원품목은 아래와 같이 정한다.</p>
			<div class="online-report-area mt-2">
				<table class="online-report-section-table" cellspacing="0" cellpadding="0">
					<tbody>
						<tr>
							<td class="pl-4">품목명:</td>
							<td class="pl-4"><p>HS Code 6단위:</p></td>
						</tr>
					</tbody>
				</table>
			</div>
			<p class="text-size-m pl-4 pt-1">2. 지원품목이 확정된 이후 참여 기간 중 이를 변경할 수 없다.</p>
			<br />
			② 진입단계 및 이에 대한 서비스 범위를 기준으로 글로벌마케터의 추가적인 지원 서비스가 필요한 경우, 고객사와 글로벌마케터는 상호 협의를 통해
			추가비용 및 구체적 내용에 대한 별도의 계약을 체결한다.<br />
		</div>
		<div class="color-navy content mt-4 text-size-l">
			<p class="font-bold mb-2">제6조 (지원의 제한)</p>
			<p>① 다음 각 호의 사항은 해외지사화사업의 지원 범위에서 제외되며 고객사는 글로벌마케터에게 이를 강요할 수 없다.</p>
			<p class="text-size-m pl-4 pt-1">1. 글로벌마케터가 고객사 또는 바이어를 대신하여 법적 당사자가 되는 행위</p>
			<p class="text-size-m pl-4 pt-1">2. 해당 글로벌마케터 소속 지역 외의 바이어 접촉 및 발굴 요청</p>
			<p class="text-size-m pl-4 pt-1">3. 개인 메신저를 통한 업무 교신(단, 글로벌마케터가 허용하는 경우는 예외로 한다)</p>
			<p class="text-size-m pl-4 pt-1">4. 현지 주말 등 공휴일, 업무시간 이외의 지원</p>
			<p class="text-size-m pl-4 pt-1">5. 법적 효력이 있는 처분 문서 등 중요 문서의 번역</p>
			<p class="text-size-m pl-4 pt-1">6. A/S 기간(이하 제7조 제3항 참조) 중 A/S 업무 이외의 모든 해외지사화사업 지원</p>
			<p class="text-size-m pl-4 pt-1">
				7. 계약체결 대행, 클레임 해결, 기타 법적책임 및 분쟁이 수반되는 사항 등 OKTA의 성격과 법적 지위상 지원이 불가능하거나 상당하지 않은 활동
			</p>
			<div class="online-report-area mt-2 mb-2">
				<table class="online-report-section-table" cellspacing="0" cellpadding="0">
					<tbody>
						<tr>
							<td class="pl-4">품목명:</td>
							<td class="pl-4"><p>HS Code 6단위:</p></td>
						</tr>
					</tbody>
				</table>
			</div>
			② 고객사는 글로벌마케터로부터 제공받은 서비스(위 제5조상의 지원대상 관련 정보 포함)를 제3자에게 공개, 제공할 수 없다.<br />
		</div>
		<div class="color-navy content mt-4 text-size-l">
			<p class="font-bold mb-2">제7조 (협약 기간 및 연장)</p>
			<p>
				① 고객사에 대한 글로벌마케터의 지원기간은
				<span class="font-bold color-gray-bg pl-1 pr-1 text-size-ml">2020년 05월 01일로부터 2020년 10월 31일</span>까지 한다. 단, 『해외지사화사업』의
				일반규정 혹은 OKTA의 관련 지침이 있는 경우 이러한 범위 내에서 쌍방 합의 하에 그 기간을 조정할 수 있다.
			</p>
			<p>② 고객사는 글로벌마케터로부터 제공받은 서비스(위 제5조상의 지원대상 관련 정보 포함)를 제3자에게 공개, 제공할 수 없다.</p>
			<p>
				③ 협약이 종료되었을 경우 진입 단계는 1개월의 A/S 기간을 제공하며, A/S는 고객사의 별도 요청이 있을 시에 한하여 제공한다. A/S 기간에는 협약기간
				중 상담을 진행해왔던 바이어와의 상담에 한하여 후속 지원을 하며, 신규 거래선 및 바이어 발굴 서비스는 제공하지 아니한다.
			</p>
		</div>
		<div class="color-navy content mt-4 text-size-l">
			<p class="font-bold mb-2">제8조 (참가비)</p>
			<p>
				① 고객사는 수익자부담 원칙에 따라 해외지사화사업에 소요되는 경비 중 일부로서 협약기간에 해당하는 참가비
				<span class="font-bold color-gray-bg pl-1 pr-1 text-size-ml">50</span>만원을 『해외지사화사업』의 공고에 따라 정하여 지는 일자까지 전액
				납부한다. 고객사가 납부기한까지 참가비를 완납하지 않는 경우 해외지사화사업에 참가할 수 없으며 해외지사화사업을 신청한 다른 국내업체로
				지원대상을 변경할 수 있다.
			</p>
			<p>
				② 유료광고 게재, 지방출장 상담, 샘플, 자료구입 및 발송 등 별도의 비용을 필요로하는서비스에대해 고객사는 해당 실비를 별도로 부담하며, 해당
				비용은 글로벌마케터와 사전 협의하여 정한다. 특히, 고객사가 글로벌마케터에게 현지 지방출장을 의뢰하는 경우, 지원여부 및 출장비용 부담은 OKTA의
				『 해외지사화사업 글로벌마케터 출장지원 지침』에 의거하여 양자 간 합의 후 결정한다.
			</p>
		</div>
		<div class="color-navy content mt-4 text-size-l">
			<p class="font-bold mb-2">제9조 (성과인센티브)</p>
			<p>
				① 글로벌마케터는 본 협약기간 중 글로벌마케터의 제5조 제2항에 따른 추가적 지원 서비스로 인하여 제5조 제1항의 제품판매가 일어날 경우, 양 당사자
				협의에 의해 인센티브(이하 “성과 인센티브”)의 액수를 정하는 별도의 성과 인센티브 계약(위 제5조 제2항상의 별도 계약서 내 포함 가능)을 체결하거나
				제17조에 특약하여 진행한다.
			</p>
			<p>
				② 고객사는 본 협약에 따라 글로벌마케터의 지원활동의 성과로서 발생하는 판매내역을 글로벌마케터에게 제공하여야 하며, 글로벌마케터는 이와 같은
				판매내역 관련 정보의 제공을 고객사에게 요청할 수 있다.
			</p>
		</div>
		<div class="color-navy content mt-4 text-size-l">
			<p class="font-bold mb-2">제10조 (글로벌마케터와 고객사의 의무)</p>
			<p>
				① 글로벌마케터는 고객사가 본 협약에서 정한 요청사항을 지원하기 위하여 최대한 노력하며, 그 수행 결과를 고객사에 대하여 보고하여야 한다.
			</p>
			<p>
				② 고객사는 자사의 요청사항을 글로벌마케터가 원활하게 수행할 수 있도록 카탈로그 및 필요자료, 샘플, 수출 실적 증빙 등 글로벌마케터가 요청하는
				자료를 적시에 글로벌마케터에게 제공하여야 하며 글로벌마케터의 업무교신 요청에 적극적으로 협조하여야 한다.
			</p>
			<p>
				③ 고객사가 고가의 샘플을 글로벌마케터에게 제공 시 고객사는 가격을 사전에 글로벌마케터에게 알려주고 철저한 관리를 요청하여야 한다.
			</p>
			<p>
				④ 고객사는 해외지사화 사업과 관련하여 부정청탁 및 금품 등 수수의 금지에 관한 법률에 위배되는 행위를 하거나 OKTA 및 글로벌마케터들에게 위
				법률에 위배되는 행위를 하도록 하여서는 안된다.
			</p>
		</div>
		<div class="color-navy content mt-4 text-size-l">
			<p class="font-bold mb-2">제11조(명의 사용의 불허)</p>
			<p>고객사는 대외적으로 글로벌마케터가 고객사의 해외사무소(지사) 임을 명기하거나 주장하지 아니한다.</p>
		</div>
		<div class="color-navy content mt-4 text-size-l">
			<p class="font-bold mb-2">제12조(사업의 중도해지)</p>
			<p>
				① 고객사는 다음 각 호의 사유가 있는 경우본협약의해지를요청할수있다. 단, 고객사는 해지 전에 OKTA에 해지사유를 통지하고 이에 대한 확인 및 협의를
				거친 후 해지여부를 결정하도록 한다.
			</p>
			<p class="text-size-m pl-4 pt-1">
				1. 글로벌마케터의 지원 부족으로 참가목적 달성이 불가능한 경우
			</p>
			<p class="text-size-m pl-4 pt-1">
				2. 시장상황의 변화 등 사정변경으로 참가목적 달성이 불가능하다고 글로벌마케터가 동의하는 경우
			</p>
			<p class="text-size-m pl-4 pt-1">
				3. 글로벌마케터가 소속된 지역의 OKTA 지회가 폐쇄되는 경우
			</p>
			<p>
				② 글로벌마케터는 다음각호의사유가있는경우본협약의해지를요청할수있다.단,글로벌마케터는 해지 전에 OKTA에 해지사유를 통지하고 이에 대한 확인 및
				협의를 거친 후 해지여부를 결정하도록 한다.
			</p>
			<p class="text-size-m pl-4 pt-1">
				1. 제10조 제2항을 위반하는 등 고객사의 관심 부족으로 사업수행에 상당한 차질이 예상되는 경우
			</p>
			<p class="text-size-m pl-4 pt-1">
				2. 고객사가 현지 거래선에 금전적 손해를 입힐 것으로 우려되는 경우
			</p>
			<p class="text-size-m pl-4 pt-1">
				3. 제10조 제4항을 위반하는 등 고객사가 OKTA 또는 글로벌마케터의 위상에 심대한 피해를 끼칠 것으로 우려되는 경우
			</p>
			<p class="text-size-m pl-4 pt-1">
				4. 제6조 제1, 2항을 위반한 경우
			</p>
			<p class="text-size-m pl-4 pt-1">
				5. 시장상황의 변화 등 사정변경으로 참가목적 달성이 불가능하다고 고객사가 동의하는 경우
			</p>
			<p class="text-size-m pl-4 pt-1">
				6. 해외지사화사업 참여 목적이 경쟁기업의 시장진입을 막기 위한 것으로 판단될 경우
			</p>
			<p class="text-size-m pl-4 pt-1">
				7. 글로벌마케터에게 합리적인 기준으로 보아 부당하거나 무리한 요구를 하는 경우
			</p>
			<p class="text-size-m pl-4 pt-1">
				8. 폭언, 욕설로서 글로벌마케터의 정상적인 업무를 방해하는 경우
			</p>
			<p class="text-size-m pl-4 pt-1">
				9. 협약기간 중 고객사가 지원 불가 대상(대기업 및 그 출자회사, 공공기관 등)으로 전환된 경우
			</p>
			<p class="text-size-m pl-4 pt-1">
				10. 고객사의 해산 또는 청산 절차가 시작되는 경우
			</p>
			<p>
				③ 본조 제1항, 제2항에 따라 고객사 또는 글로벌마케터의 요청으로 사업이 중도 해지되는 경우, 즉시 OKTA에 통지하고 귀책사유의 소재 및 해지사유를
				고려하여 참가비 및 활동비 등의 소요비용은 아래와 같이 정산한다.
			</p>
			<p class="text-size-m pl-4 pt-1">
				1. 본 협약이 해지 또는 해제되는 경우, 중도해지 또는 해제된 익월부터 월할 정산하여 참가비를 환불한다.
			</p>
			<p class="text-size-m pl-4 pt-1">
				2. 본 협약이 해지 또는 해제되는 경우, 활동비 반환 등은 해외지사화사업 운영지침에 따라 처리한다.
			</p>
		</div>
		<div class="color-navy content mt-4 text-size-l">
			<p class="font-bold mb-2">제13조(책임소재 등)</p>
			<p>
				① 고객사는 글로벌마케터로부터 소개받은 바이어와 거래함에 있어 전적으로 고객사의 책임 하에 의사결정하고 글로벌마케터는 이에 따른다.
			</p>
			<p>
				② 고객사는 전항의 거래에서 야기되는 신용상, 재정상 등의 모든 문제와 분쟁에 대하여 전적으로 책임을 지며, 글로벌마케터 및 OKTA에게 법적, 경제적
				책임을 물을 수 없다.
			</p>
			<p>
				③ 글로벌마케터는 사업을 수행하는 과정에서 알게 된 고객사의 영업기밀에 관한 사항을 누설하지 아니한다.
			</p>
		</div>
		<div class="color-navy content mt-4 text-size-l">
			<p class="font-bold mb-2">제14조(관계)</p>
			<p>
				본 협약의 체결이 양 당사자간의 동업, 대리인, 프랜차이즈 혹은 고용이나 합작관계를 구성하는 것은 아니며, 본 협약에서 명시적으로 규정한 의무
				이외에 양 당사자 상호간 사업이나 경영을 구속하는 법적관계에 있지 않으며, OKTA 또한 본 계약상 제공되는 서비스 내용이나 결과와는 전혀 무관하다.
			</p>
		</div>
		<div class="color-navy content mt-4 text-size-l">
			<p class="font-bold mb-2">제15조(준거법 및 분쟁 해결)</p>
			<p>
				① 본 협약은 대한민국 법률에 따라 해석되고 규율된다.
			</p>
			<p>
				② 해외지사화사업을 수행하는 과정에서 고객사와 글로벌마케터가 본 협약의 해석 또는 협약에서 명기하지 않은 사항에 대해 분쟁이나 이견이 발생하는
				경우 최대한 상호 협의를 통하여 해결하고자 노력하여야 하며, 이러한 분쟁이나 이견이 원만히 해결되지 않는 경우에는 OKTA의 조정절차에 따른
				조정으로 해결할 것을 원칙으로 한다. 조정에 의하여서도 해결이 불가할 경우 대한민국 서울에서 대한상사중재원의 국제중재규칙에 따라 중재로 최종
				해결한다. 본 중재판결은 최종적인 것이며 양 당사자를 구속하고, 양 당사자는 중재판결에 기하여 법원의 집행명령을 청구할 수 있다.
			</p>
		</div>
		<div class="color-navy content mt-4 text-size-l">
			<p class="font-bold mb-2">제16조(효력)</p>
			<p>
				① 본 협약은 <span class="font-bold color-gray-bg pl-1 pr-1 text-size-ml">2020년 05월 01일로부터 2020년 10월 31일</span>까지 효력을 갖는다.
			</p>
			<p>
				② 본 협약의 기간만료 내지 중도해지(제)로 인하여 종료되는 경우에도 그 성질상 효력을 유지하여야 하는 조항은 본 협약의 종료 이후에도 유효하다.
			</p>
		</div>

		<div class="color-navy content mt-4 text-size-l">
			<p class="font-bold mb-2">제17조 (기타 특약사항)</p>
			<p>(해당지역의 사업수행 여건과 특성을 고려한 필요사항 추가반영)</p>
			<p>첨부1. 개인(기업)정보 목적 외 이용 및 제3자 제공 동의서(필수) 1부.</p>
			<p>첨부2. 해외지사화사업 글로벌마케터 출장지원 지침 1부.</p>
		</div>

		<div class="color-navy content mt-4 text-size-ml">
			<p class="font-bold mb-2 text-center">2020년 10월 10일</p>
			<table class="w-20">
				<tr class="text-center">
					<td class="col-w50 text-center">팜피주식회사</td>
					<td class="col-w50 text-center">글로벌마케터 손지창</td>
				</tr>
			</table>
		</div>
	</div>
</template>

<script>
import CONST from '@/constants';

export default {
	name: 'Agreement-Entry',
	props: ['matchData', 'apiData'],
	created() {},
	mounted() {
		this.$device.sendEvent(CONST.EVENTS.SET_SIDE_MENU, 'BIZ');
	},
};
</script>

<style scoped></style>
